<template>
    <div class="bg-white overflow-hidden shadow rounded-lg m-auto w-3/5 one-page">

        <div v-if="tempSection.header_image_url" class="text-center w-100">
            <img class="object-cover h-auto w-auto mb-5" :src="tempSection.header_image_url">
        </div>

        <div class="px-4 py-5 sm:p-6 min-h-screen-60">
            <div>
                <div v-if="section['url']" class="mt-2">
                    <img height="375" width="793" :src="section['url']">
                </div>

                <table style="width: 100%;">
                    <tr>
                        <td style="vertical-align: top; align: center;">
                            <div style="text-align: center; margin-top: 50px;">
                                <div
                                    style="font-weight: bold; text-transform: uppercase; font-size: 25px; letter-spacing: .5px;">
                                    {{ section['project'].name }}
                                </div>
                                <div style="margin-top: 5px; font-size: 14px;">
                                    {{ section['project'].address }}
                                </div>
                                <div style="font-size: 14px; margin-bottom: 40px">
                                    {{address(section)}}
                                </div>
                            </div>
                        </td>
                        <td style="width: 5%;"></td>
                    </tr>
                </table>

                <div style="margin-top: 40px;">
                    <div class="flex font-bold text-xl tracking-normal justify-content-around container">
                        <div class="pl-5">
<!--                            <div v-if="section['company']">Proposal for</div>-->
<!--                            <div v-if="section['company']">{{ section['company'].name }}</div>-->
<!--                            <div v-else>-->
<!--                                {{ section['project'].name }}-->
<!--                            </div>-->
                        </div>
                        <div class="pl-5">
<!--                            <div>Created by</div>-->
<!--                            <div>{{ companyName }}</div>-->
                        </div>
                    </div>
                    <div class="col-md-12 mt-5 flex font-light text-xl tracking-normal justify-content-around container">
                        <div class="col-md-4">
                            <h4 class="mb-2">Proposal for</h4>
                            <div v-if="section['companyContact']">
                                <div>{{ section['companyContact'].name }}</div>
                                <div><a :href="'mailto:'+proposalForEmail">{{ proposalForEmail }}</a></div>
                                <div>{{ section['companyContact'].cell }}</div>
                            </div>
                            <div v-else>
                                <div>{{ section['projectContact'].name }}</div>
                                <div><a :href="'mailto:'+proposalForEmail">{{ proposalForEmail }}</a></div>
                                <div>{{ section['projectContact'].cell }}</div>
                            </div>
                        </div>
                        <div class="col-md-4">
                        </div>
                        <div class="col-md-4">
                            <h4 class="mb-2">Created by</h4>
                            <div>{{ section['createdBy'].name }}</div>
                            <div><a :href="'mailto:'+createdByEmail">{{ createdByEmail }}</a></div>
                            <div>{{ section['createdBy'].phone }}</div>
                        </div>
                    </div>
                </div>


                <div class="mt-3 flex justify-center">
                    <table v-if="section.signature_section" class="table-auto">
                        <tr>
                            <th colspan="3" class="px-2 text-white" :style="colorStyle"
                                style="border: 1px solid #000; text-weight: 200;">
                                Please confirm your acceptance of this quote by signing this document
                            </th>
                        </tr>
                        <tr>
                            <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer && tempSection.signer.signed_name ? tempSection.signer.signed_name : 'Signature' }}</td>
                            <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer && tempSection.signer.signed_name ? tempSection.signer.signed_name : 'Print Name' }}</td>
                            <td style="color:#aaa; border: 1px solid #000; padding: 2px">{{ tempSection.signer ? tempSection.signer.created_at.moment('m/d/Y h:i:s A') : 'Date' }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="tempSection.footer_image_url" class="border-gray-200 mt-5 proposal-footer">
            <img class="object-cover h-auto" :src="tempSection.footer_image_url">
        </div>
    </div>
</template>

<script>
export default {
    props   : ['section', 'tempSection'],
    name    : "preview-introduction",
    data() {
        return {
            companyName: '',
            createdByEmail: this.section['createdBy'].email,
            proposalForEmail: this.section['companyContact'] != null? this.section['companyContact'].email:this.section['projectContact'].email,
        }
    },
    computed: {
        colorStyle() {
            return {
                "background-color": this.tempSection.color,
            };
        }
    },
    methods: {
        address(section) {
            let result = [];
            if (section['project'].city) {
                result.push(section['project'].city);
            }
            if (section['project'].state) {
                result.push(section['project'].state);
            }
            if (section['project'].zip) {
                result.push(section['project'].zip);
            }
            return result.join(', ')
        }
    }
}
</script>

<style scoped>
p {
    margin-top: 0;
    margin-bottom: 0;
}

.font-style {
    font-family: "Source Sans Pro", Calibri, Candara, Arial, sans-serif;
}

.header-image {
    position: fixed;
    top: -50px;
    padding-right: -50px;
    padding-left: -50px;
    padding-bottom: -50px;
    width: 100%;
}

.footer-image {
    position: fixed;
    bottom: 100px;
    margin-top: 20px;
    padding-left: -50px;
    padding-right: -50px;
    width: 100%;
}
</style>
